import { useMemo } from "react";
import { Platform, StatusBar } from "react-native";

import { useSafeAreaInsets } from "../SafeAreaExports";

export const useHeaderHeight = () => {
  const insets = useSafeAreaInsets();
  const headerHeight = useMemo(
    () =>
      Platform.select({
        android: 44 + (insets.top || StatusBar.currentHeight || 0),
        default: 44 + insets.top,
      }),
    [insets.top],
  );

  return headerHeight;
};
